/* eslint-disable camelcase */
import styled from '@emotion/styled'

import type { FC } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import SignupButton from '@segment/matcha/recipes/SignupButton'

const copy = {
  heading: `Easily personalize customer experiences with first-party data`,
  description: `With a huge integration catalog and plenty of no-code features, Segment provides easy-to-maintain capability to your teams with minimal engineering effort. Great data doesn't have to be hard work!`,
  link: `Get started for free`,
}

interface CtaProps {
  title: string | undefined
}

const Cta: FC<CtaProps> = ({ title }) => {
  return (
    <StyledColumnTrack columns={1}>
      <CopyTextBase>
        <CopyText.Heading tag="h2" variant="h5">
          {title && title !== `` ? title : copy.heading}
        </CopyText.Heading>
        <CopyText.Description variant="pMedium">{copy.description}</CopyText.Description>
      </CopyTextBase>
      <SignupButton
        linkToApp={false}
        size="medium"
        additionalParams={{ utm_source: `site`, utm_medium: `referral`, utm_campaign: `all_devrel_recipes-cta` }}
      >
        {copy.link}
      </SignupButton>
    </StyledColumnTrack>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  row-gap: 40px;
  justify-items: start;
`

export default Cta
